import { ApprovalsPage } from "./ApprovalsPage";
import { ReviewPage } from "./ReviewPage";

import { DocumentIcon } from "@/components/icons";
import type { FeatureModule } from "@/types/feature";

/** Director approvals: the queue and the review/decision screen. */
export const approvalsFeature: FeatureModule = {
  id: "approvals",
  navItems: [
    {
      id: "approvals",
      label: "Approvals",
      path: "/approvals",
      icon: DocumentIcon,
      requires: "cms.approve",
    },
  ],
  routes: [
    { path: "approvals", element: <ApprovalsPage /> },
    { path: "approvals/:versionId", element: <ReviewPage /> },
  ],
};
